/**
 * Laufzeit-Konfiguration — Domain bleibt flexibel.
 *
 * Auflösungsreihenfolge (erste gewinnt):
 *   1. window.__APP_CONFIG__  (public/config.js — pro Domain überschreibbar, ohne Rebuild)
 *   2. import.meta.env.VITE_* (Build-Zeit-Defaults)
 *   3. eingebauter Fallback
 *
 * So kann später z. B. www.ki-pocket-guru.de auf dieselbe Build-Ausgabe zeigen,
 * indem nur config.js angepasst wird. Keine Domain ist im Bundle hartkodiert.
 */

export interface AppConfig {
  /** Basis-URL der FastAPI (ohne abschließenden Slash). */
  apiBaseUrl: string;
  /** Kurs, den v1 standardmäßig öffnet. */
  defaultCourseId: string;
}

declare global {
  interface Window {
    __APP_CONFIG__?: Partial<AppConfig>;
  }
}

const runtime: Partial<AppConfig> =
  (typeof window !== "undefined" && window.__APP_CONFIG__) || {};

function trimSlash(url: string): string {
  return url.replace(/\/+$/, "");
}

export const config: AppConfig = {
  apiBaseUrl: trimSlash(
    runtime.apiBaseUrl ||
      import.meta.env.VITE_API_BASE_URL ||
      "https://ki-kurs.sentinus.de",
  ),
  defaultCourseId:
    runtime.defaultCourseId ||
    import.meta.env.VITE_DEFAULT_COURSE_ID ||
    "sentinus-ki-kurs",
};
